export default "__VITE_ASSET__B6cHLQW7__"